export default "__VITE_ASSET__vAiG0rmf__"